import { createContext } from "react"

const info1=createContext(
    {
        user:{
            name:"dummy",
            email:"dummy@gmail.com",
          
        },
    
    }
);

export default info1;